import { Badge, ModalContainer, SectionHeader } from "../../../components";
import {
  HookFormSelect,
  SubmitButton,
  TextArea,
  TextInput,
} from "../../../hook-form";
import { IInviteTeamMemberFormViewProps } from "./InviteTeamMemberForm";

export const View = ({
  isModalOpen,
  closeModal,

  errors,
  handleSubmit,
  register,

  // userAccessClaimsFieldArray,
  appendNewUserAccessClaim,
  removeUserAccessClaim,

  // values used for settings form
  formValues,
  isLoadingAvailableAccessClaims,
  isErrorAvailableAccessClaims,
  availableAccessClaims,
}: IInviteTeamMemberFormViewProps) => {
  console.log("formValues.user_access_claims", formValues.user_access_claims);

  return (
    <form onSubmit={handleSubmit}>
      <ModalContainer
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        modalHeader={
          <SectionHeader
            title={`Invite Team Member`}
            subtitle="Grow your team on SwitchApp."
            renderRight={
              <SubmitButton
                size="sm"
                className="ml-5 mr-5 pl-5 pr-5"
                showChildrenWithLoadingIcon
              >
                Send Invitation
              </SubmitButton>
            }
          />
        }
      >
        <TextInput
          name="email"
          label="Email"
          infoIconText="Email of the user you are inviting"
          type="text"
          register={register}
          errors={errors}
        />

        <TextArea
          name="message"
          label="Email Message (Optional)"
          infoIconText="Message that will be attached to the email"
          register={register}
          errors={errors}
        />

        <HookFormSelect
          name="availableAccessClaimsSelectHelper"
          label="Access Roles"
          infoIconText="Roles your new team member will have in your organization."
          placeholder="Please select a role"
          showSkeleton={isLoadingAvailableAccessClaims}
          selectItems={[]}
          selectGroupedItems={[
            {
              groupLabel: ``,
              options: [
                {
                  text: "SELECT A ROLE",
                  value: "", // placeholder to escape first item selection bug
                },
              ],
            },
            ...availableAccessClaims.map((claim) => ({
              groupLabel: `${claim.description}`,
              options: [
                {
                  text: claim.claim,
                  value: claim.claim,
                },
              ],
            })),
          ]}
          onChange={(e) =>
            // NOTE: change can be setting to null
            e.target?.value && appendNewUserAccessClaim(e.target.value)
          }
          register={register}
          errors={errors}
        />

        <div className="mt-5">
          <strong className="mr-5">Roles The New User Will Be Added To:</strong>

          <strong className="text-danger">
            {errors["user_access_claims"] ? (
              <p>{errors["user_access_claims"].message}</p>
            ) : null}
          </strong>

          <div className="flex-container">
            {formValues.user_access_claims?.map((claim, index) => (
              <div
                className="mr-5 cursor-pointer"
                title="Click to remove role"
                onClick={() => removeUserAccessClaim(claim)}
              >
                <Badge
                  text={claim}
                  statusColor={
                    claim.toLowerCase().includes("owner")
                      ? "teal"
                      : claim.toLowerCase().includes("admin")
                      ? "primary"
                      : "warning"
                  }
                  className="pl-5 mt-5"
                  indicatorComponent={
                    <span className="pl-5 text-danger font-ctm--bold">
                      &times;
                    </span>
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </ModalContainer>
    </form>
  );
};
